import { useState, useEffect } from "react";

/**
 * Hook to determine if the component is running on the client side.
 * Useful for preventing hydration mismatches by only rendering certain
 * components after hydration is complete.
 *
 * @returns boolean - true if running on client, false during SSR
 */
export const useIsClient = (): boolean => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};
